import { useState } from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import "../styles/Contact.css";
const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Message sent successfully!");
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        {/* Contact Form on the Left */}
        <Col md={6}>
        <h2 className="contact-heading">Contact Us</h2>
          <Form onSubmit={handleSubmit}>
            {/* Name Field */}
            <Form.Group className="mb-3" controlId="name">
              
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your name"
                required
              />
            </Form.Group>

            {/* Email Field */}
            <Form.Group className="mb-3" controlId="email">
              
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </Form.Group>

            {/* Message Field */}
            <Form.Group className="mb-3" controlId="message">
             
              <Form.Control
                as="textarea"
                rows={4}
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Enter your message"
                required
              />
            </Form.Group>

            {/* Submit Button */}
            <Button variant="primary" type="submit" className="w-100">
              Send Message
            </Button>
          </Form>
        </Col>

        {/* Business Info on the Right */}
        <Col md={6} className="mt-4 mt-md-0">
         

        <div className="business-info">
  <h4>Visit Our Store for Fresh Samples</h4>
  

  <p><i className="fas fa-map-marker-alt"></i> <strong>Sal Pita Inc</strong></p>
   <p>910 20th Street West, Saskatoon, Saskatchewan S7M 0Y4, Canada </p>


  <p><i className="fas fa-phone"></i> <strong> Phone:</strong> 306.373.7482</p>

  <h5>Business Hours</h5>
  <table className="business-hours">
    <tbody>
      <tr><th>Day</th><th>Hours</th></tr>
      <tr><td>Monday</td><td>10:00 AM – 6:00 PM</td></tr>
      <tr><td>Tuesday</td><td>10:00 AM – 6:00 PM</td></tr>
      <tr><td>Wednesday</td><td>10:00 AM – 6:00 PM</td></tr>
      <tr><td>Thursday</td><td>10:00 AM – 6:00 PM</td></tr>
      <tr><td>Friday</td><td>10:00 AM – 6:00 PM</td></tr>
      <tr><td>Saturday</td><td>10:00 AM – 6:00 PM</td></tr>
      <tr><td>Sunday</td><td>10:00 AM – 6:00 PM</td></tr>
    </tbody>
  </table>
</div>
        </Col>
      </Row>

      {/* Full-width Google Map */}
      <Row className="mt-4">
        <Col>
          <div className="map-container">
            <iframe
              title="Google Map"
              width="100%"
              height="350"
              frameBorder="0"
              style={{ border: 0 }}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2346.365270204665!2d-106.68933272270769!3d52.11692707225309!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5304f1f0e0b0c6c1%3A0xeca2f4f0e7edb80d!2s910%2020th%20St%20W%2C%20Saskatoon%2C%20SK%20S7M%200Y4%2C%20Canada!5e0!3m2!1sen!2sca!4v1707075600000"
              allowFullScreen
            ></iframe>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Contact;
